<template>
    <modal
        :initial-show="true"
        @after-open="registerSuccessListener"
        @after-close="afterClose"
        class="checkout-modal no-offset"
        modal-width="100%" modal-height="100%"
        ref="modal"
        v-if="show"
    >
        <template slot="header">
            {{ $t__('Checkout') }}
        </template>

        <template slot="body">
            <iframe :src="iframeSrc" ref="iframe"></iframe>
        </template>
    </modal>
</template>

<script>
    import * as utils from '../support/utils';

    export default {
        name: 'CheckoutModal',

        props: {
            planId: {
                type: Number,
                required: true
            },
            initialShow: false,
            refreshOnSuccess: false
        },

        computed: {
            iframeSrc() {
                return `${this.checkoutUrl}/?embedded&id=${this.planId}`;
            }
        },

        data: () => ({
            success: false,
            show: false,
            checkoutUrl: utils.baseUrl('checkout')
        }),

        created() {
            this.show = this.initialShow;
        },

        methods: {
            registerSuccessListener() {
                addEventListener('message', e => {
                    if (e.origin !== this.checkoutUrl ||
                        e.source !== (this.$refs.iframe.contentWindow || this.$refs.iframe.contentDocument) ||
                        e.data !== 'success') return;

                    setTimeout(() => {
                        if (this.refreshOnSuccess) this.refreshPage();
                        this.success = true;
                        this.$refs.modal.close();
                    }, 3000);
                }, false);
            },

            afterClose() {
                if (this.success) {
                    this.$emit('success');
                } else {
                    this.$emit('cancel');
                }

                this.show = false;
            },

            refreshPage() {
                var location = window.location.href.split("?")[0];
                window.location.href = location.split("#")[0];
            }
        }
    }
</script>
